const XAPP_GREEN = "#39d75a";
const XAPP_GREY = "#3e3e3e";
const XAPP_RED = "#e94949";
const XAPP_WHITE = "#fff";

const boxShadowReset = {
    MozBoxShadow: `0 1px 1px ${XAPP_GREY}`,
    WebkitBoxShadow: `0 1px 1px ${XAPP_GREY}`,
    boxShadow: `0 1px 1px ${XAPP_GREY}`
};

export default {
    Dismiss: {
        error: {
            backgroundColor: XAPP_WHITE,
            color: XAPP_RED
        },
        success: {
            backgroundColor: XAPP_WHITE,
            color: XAPP_GREEN
        }
    },
    NotificationItem: {
        DefaultStyle: {
            borderRadius: 0
        },
        error: {
            ...boxShadowReset,
            backgroundColor: XAPP_WHITE,
            borderTop: `2px solid ${XAPP_RED}`
        },
        success: {
            ...boxShadowReset,
            backgroundColor: XAPP_WHITE,
            borderTop: `2px solid ${XAPP_GREEN}`
        }
    },
    Title: {
        error: {
            color: XAPP_RED
        },
        success: {
            color: XAPP_GREEN
        }
    }
};
